import { postJson } from '@zapier/toolbox-browser-fetch';
import { TrackingMiddleware } from '../types';
import { isBrowser, isInIframe, isInPopup } from '../utils';

const CONTEXT_ENV = isBrowser() ? 'client' : 'server';

const sendToBackend: TrackingMiddleware = config => async event => {
  const { service, baseUrl = '' } = config.get(['service', 'baseUrl']);

  if (event.name.startsWith('schema:')) {
    // If the event.name begins with 'schema:` we'll use the event.name value
    // that follows 'schema:' to represent the Avro schema for the provided
    // event.data.   We'll use the v4 Events API to emit these events.
    const schemaName = event.name.split(':')[1];

    // We'll include additional `context` data in the properties payload.
    // If the Avro schema referenced by event.name does not define a `context`
    // field in the schema definition, this data will be dropped because
    // the v4 events API uses the events_toolkit's ignore_extra_fields mode.
    const url = `${baseUrl}/api/v4/tracking/event/`;
    const {
      identity_id,
      utm_campaign,
      utm_content,
      utm_medium,
      utm_source,
    } = event.context;

    let page_path = null;
    let screen_size = null;
    let iframe_flag = null;
    let popup_flag = null;
    let user_agent = null;
    let url_address = null;
    let query_string = null;
    let fully_qualified_domain_name = null;

    if (isBrowser()) {
      // for browser based events, like PageViewEvent, we want to collect common Avro event
      // properties here prior to making the v4 Events API request to emit the event
      fully_qualified_domain_name = window.location.hostname;
      url_address = window.location.href;
      page_path = window.location.pathname;
      query_string = window.location.search;
      user_agent = window.navigator.userAgent;

      const width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const height =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      screen_size = `${width}x${height}`;

      iframe_flag = isInIframe();
      popup_flag = isInPopup();
    }

    await postJson(url, {
      subject: schemaName,
      properties: {
        ...event.data,
        identity_id,
        fully_qualified_domain_name,
        url_address,
        query_string,
        page_path,
        screen_size,
        iframe_flag,
        popup_flag,
        user_agent,
        utm_content,
        utm_medium,
        utm_source,
        utm_campaign,
        // When all Avro events have adopted the latest data governance guidance for events,
        // we can remove this nested `context` as top level fields are now preferred.
        context: {
          [`${service || ''}__${CONTEXT_ENV}`]: event.context,
        },
      },
    });
  } else {
    // The v3 events API will remain the default while we continue to work
    // on the v4 migration.
    const url = `${baseUrl}/api/v3/events`;

    await postJson(url, {
      message: event.name,
      data: {
        ...event._deprecatedBuildProprtiesInRoot(),
        ...event.data,
        _data: event.data,
        _context: {
          [`${service || ''}__${CONTEXT_ENV}`]: event.context,
        },
      },
    });
  }
};

export default sendToBackend;
